import { render } from "./AccountLayout.vue?vue&type=template&id=63e71b21&scoped=true"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=63e71b21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e71b21"]])

export default __exports__